// Operator data for typed Knowledge Explore filtering. Plain tables, no logic.
// Op values mirror the server `FilterOp` enum (nlu-runtime/knowledge/gql/filtering.py)
// exactly — they are sent verbatim as the `op` of each { field, op, value } filter.

export const VALUE_SHAPES = {
  SCALAR: "scalar",
  LIST: "list",
  NONE: "none",
  ENTITY: "entity",
  CONFIG: "config"
};

export const KNOWLEDGE_FILTER_OPERATORS = {
  CONTAINS: { op: "CONTAINS", label: "contains", valueShape: VALUE_SHAPES.SCALAR },
  NOT_CONTAINS: { op: "NOT_CONTAINS", label: "does not contain", valueShape: VALUE_SHAPES.SCALAR },
  IS: { op: "IS", label: "is", valueShape: VALUE_SHAPES.SCALAR },
  IS_NOT: { op: "IS_NOT", label: "is not", valueShape: VALUE_SHAPES.SCALAR },
  STARTS_WITH: { op: "STARTS_WITH", label: "starts with", valueShape: VALUE_SHAPES.SCALAR },
  ENDS_WITH: { op: "ENDS_WITH", label: "ends with", valueShape: VALUE_SHAPES.SCALAR },

  EQ: { op: "EQ", label: "equals", valueShape: VALUE_SHAPES.SCALAR },
  NEQ: { op: "NEQ", label: "does not equal", valueShape: VALUE_SHAPES.SCALAR },
  GT: { op: "GT", label: "greater than", valueShape: VALUE_SHAPES.SCALAR },
  LT: { op: "LT", label: "less than", valueShape: VALUE_SHAPES.SCALAR },
  GTE: { op: "GTE", label: "greater than or equal to", valueShape: VALUE_SHAPES.SCALAR },
  LTE: { op: "LTE", label: "less than or equal to", valueShape: VALUE_SHAPES.SCALAR },

  IS_TRUE: { op: "IS_TRUE", label: "is true", valueShape: VALUE_SHAPES.NONE },
  IS_FALSE: { op: "IS_FALSE", label: "is false", valueShape: VALUE_SHAPES.NONE },

  CONTAINS_ANY_OF: { op: "CONTAINS_ANY_OF", label: "contains any of", valueShape: VALUE_SHAPES.LIST }
};

export const FILTER_MAP_KEYS = {
  STRING: "String",
  INT: "Int",
  FLOAT: "Float",
  BOOLEAN: "Boolean",
  JSON: "JSON",
  STRING_ARRAY: "[String]",
  ASSOCIATION: "Association",
  CONFIG_REF: "ConfigRef",
  MULTI_LANGUAGE: "MultiLanguageString"
};

const STRING_OPERATORS = ["CONTAINS", "NOT_CONTAINS", "IS", "IS_NOT", "STARTS_WITH", "ENDS_WITH"];
const NUMERIC_OPERATORS = ["EQ", "NEQ", "GT", "LT", "GTE", "LTE"];

export const OPERATORS_BY_TYPE = {
  [FILTER_MAP_KEYS.STRING]: STRING_OPERATORS,
  [FILTER_MAP_KEYS.JSON]: STRING_OPERATORS,
  [FILTER_MAP_KEYS.INT]: NUMERIC_OPERATORS,
  [FILTER_MAP_KEYS.FLOAT]: NUMERIC_OPERATORS,
  [FILTER_MAP_KEYS.BOOLEAN]: ["IS_TRUE", "IS_FALSE"],
  [FILTER_MAP_KEYS.STRING_ARRAY]: ["CONTAINS_ANY_OF"],
  [FILTER_MAP_KEYS.ASSOCIATION]: ["IS"],
  [FILTER_MAP_KEYS.CONFIG_REF]: ["IS"],
  // A language-keyed map has no exact/prefix match; the server matches the
  // value inside any language, so only substring operators are offered.
  [FILTER_MAP_KEYS.MULTI_LANGUAGE]: ["CONTAINS", "NOT_CONTAINS"]
};

// Numeric columns coerce their scalar value to a number before sending.
export const NUMERIC_MAP_KEYS = [FILTER_MAP_KEYS.INT, FILTER_MAP_KEYS.FLOAT];

// Association sub-fields are matched exactly on the association row (ids, not free text),
// so their scalar sub-fields only offer exact-match operators.
export const EXACT_MATCH_OPERATORS = ["IS", "IS_NOT"];

export const getDefaultOperator = (mapKey) => OPERATORS_BY_TYPE[mapKey]?.[0] ?? null;

export const getOperatorValueShape = (operator) =>
  KNOWLEDGE_FILTER_OPERATORS[operator]?.valueShape ?? VALUE_SHAPES.SCALAR;

export const getFilterValueShape = (filter) => {
  if (filter?.mapKey === FILTER_MAP_KEYS.ASSOCIATION) return VALUE_SHAPES.ENTITY;
  if (filter?.mapKey === FILTER_MAP_KEYS.CONFIG_REF) return VALUE_SHAPES.CONFIG;
  return getOperatorValueShape(filter?.operator);
};
